import googleAnalytics from "@analytics/google-analytics";
import googleTagManager from "@analytics/google-tag-manager";
import Analytics from "analytics";

interface IdynamicList {
  [key: string]: any;
}

interface IAnalytics {
  provider: any;
  trackingId?: string;
  containerId?: string;
}
const dynamicAnalyticsProviderList: IdynamicList = {};
const pluginsArray: Array<any> = [];

const plugin = async (provider: string, data: IAnalytics, i: number) => {
  const providerArr = provider.split(",");
  if (providerArr.includes("googleAnalytics")) {
    dynamicAnalyticsProviderList["googleAnalytics"] = (
      await import(`@analytics/google-analytics`)
    ).default;
    pluginsArray[i] = dynamicAnalyticsProviderList["googleAnalytics"]({
      trackingId: data.trackingId,
    });
  }
  if (providerArr.includes("googleTagManager")) {
    /* eslint-disable */
    dynamicAnalyticsProviderList["googleTagManager"] = (
      await import(`@analytics/google-tag-manager`)
    ).default;
    pluginsArray[i] = dynamicAnalyticsProviderList["googleTagManager"]({
      containerId: data.containerId,
    });
  }
  console.log(pluginsArray, "pluginsArray");
  return pluginsArray;
};

export const analyticsInstance = async (data: IAnalytics) => {
  let analytics: Object = {};
  let res: Array<any> = [];
  if (data?.provider instanceof Array) {
    data?.provider.map(async (item, i) => {
      res = await plugin(item, data, i);
    });
  } else {
    res = await plugin(data?.provider, data, 0);
  }

  analytics = Analytics({
    app: "X-Rendering",
    // debug: true,
    plugins: [
      googleAnalytics({
        measurementIds: [process.env?.NX_PUBLIC_GA_ID],
      }),
      googleTagManager({
        containerId: process.env?.NX_PUBLIC_GTM_ID,
      }),
    ],
  });

  return analytics;
};
